import Select from 'react-select'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import CustomMenuList from './CustomMenuList'

const SelectAny: any = Select

const CustomSelect = ({
  onChange,
  options,
  value,
  className,
  placeholderText,
  isMulti,
  isDisabled,
  isLoading,
  showIcon = false,
}: any) => {
  const {t} = useTranslation()

  const [tempValue, setTempValue] = useState(isMulti ? value : null)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleSelect = (selected: any) => {
    if (selected === null || (Array.isArray(selected) && selected.length === 0)) {
      if (isMulti) {
        setTempValue([])
        onChange([])
      } else {
        onChange({id: null})
      }
      setMenuOpen(false)
      return
    }

    if (isMulti) {
      setTempValue(selected)
      setMenuOpen(true)
      return
    }

    onChange({
      ...selected,
      id: selected.id ?? null,
    })
    setMenuOpen(false)
  }

  const selectAll = () => {
    const all = options.map((o: any) => ({
      id: o.id,
      name: o.name,
    }))
    setTempValue(all)
  }

  const deselectAll = () => {
    setTempValue([])
  }

  const safeSingleValue = (() => {
    if (!value) return null
    const id = typeof value === 'object' ? value.id : value
    const found = options.find((opt: any) => opt.id === id)
    return found || null
  })()

  return (
    <div className={className}>
      <SelectAny
        isMulti={isMulti}
        isClearable={true}
        menuIsOpen={isMulti ? menuOpen : undefined}
        onMenuOpen={() => isMulti && setMenuOpen(true)}
        onMenuClose={() => isMulti && setMenuOpen(false)}
        closeMenuOnSelect={!isMulti}
        value={isMulti ? tempValue : safeSingleValue}
        options={options}
        onChange={handleSelect}
        selectAllHandler={selectAll}
        deselectAllHandler={deselectAll}
        confirmHandler={() => {
          onChange(tempValue)
          setMenuOpen(false)
        }}
        cancelHandler={() => {
          setTempValue(value)
          setMenuOpen(false)
        }}
        components={isMulti ? {MenuList: CustomMenuList} : undefined}
        getOptionLabel={(opt: any) => opt.name}
        formatOptionLabel={(opt: any) => (
          <div className='d-flex align-items-center'>
            {showIcon && opt.icon && <i className={`${opt.icon} mx-2 text-primary`}></i>}
            <span>{opt.name}</span>
          </div>
        )}
        getOptionValue={(opt: any) => (opt ? opt.id : '')}
        isDisabled={isDisabled}
        isLoading={isLoading}
        placeholder={t('VALIDATION.SELECT_', {name: placeholderText})}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base: any) => ({...base, zIndex: 9999}),
        }}
      />
    </div>
  )
}

export default CustomSelect
